/* ==========================================================================
   Kopstorm K_44 · New buy box on the product page (Anavrin, 3 Nov 2026)
   kopstorm-k44.js, loaded by snippets/kopstorm-k44-buybox.liquid

   The quantity steps, the kit lines, the kit popup, the add to cart hand-off
   and the fading promises. Everything only acts while <html> carries kop-k44
   and the box is visible, so the control arm keeps the V4 page untouched.
   ========================================================================== */
(function () {
  'use strict';

  var root = document.documentElement;
  var params = new URLSearchParams(window.location.search);

  function flagOn() {
    return root.classList.contains('kop-k44');
  }

  function visible(el) {
    return !!el && !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
  }

  function readJson(el) {
    if (!el) return {};
    try { return JSON.parse(el.textContent) || {}; } catch (e) { return {}; }
  }

  function money(cents) {
    var t = window.theme || {};
    var s = t.settings || {};
    var fmt = s.currencyCodeEnabled ? s.moneyWithCurrencyFormat : s.moneyFormat;
    if (t.Currency && typeof t.Currency.formatMoney === 'function') return t.Currency.formatMoney(cents, fmt || '${{amount}}');
    return '$' + (cents / 100).toFixed(2);
  }

  /* Store time "2026-11-15 13:00" plus the store offset "+0800" to a UTC
     timestamp, the same reading as snippets/kopstorm-ea.liquid. */
  function storeTime(value, tz) {
    var p = /^(\d{4})-(\d\d)-(\d\d)(?:[ T](\d\d):(\d\d))?$/.exec((value || '').trim());
    if (!p) return 0;
    var m = /^([+-])(\d\d)(\d\d)$/.exec(tz || '');
    var off = 0;
    if (m) {
      off = (parseInt(m[2], 10) * 60 + parseInt(m[3], 10)) * 60000;
      if (m[1] === '-') off = -off;
    }
    return Date.UTC(+p[1], +p[2] - 1, +p[3], +(p[4] || 0), +(p[5] || 0)) - off;
  }

  function BuyBox(el) {
    this.el = el;
    this.text = readJson(el.querySelector('[data-k44-text]'));
    this.labels = readJson(el.querySelector('[data-k44-labels]'));
    this.formId = el.getAttribute('data-form');
    this.perPage = parseInt(el.getAttribute('data-per-page'), 10) || 5;
    this.self = {
      id: el.getAttribute('data-variant'),
      price: parseInt(el.getAttribute('data-price'), 10) || 0,
      title: el.getAttribute('data-title'),
      image: el.getAttribute('data-image'),
      srcset: el.getAttribute('data-srcset'),
      self: true
    };
    this.qty = 1;
    this.pct = 0;
    this.slots = [this.self];
    this.steps = Array.prototype.slice.call(el.querySelectorAll('[data-k44-step]'));
    this.slotsEl = el.querySelector('[data-k44-slots]');
    this.slotTpl = el.querySelector('[data-k44-slot-tpl]');
    this.shipEl = el.querySelector('[data-k44-ship]');
    this.saveEl = el.querySelector('[data-k44-save]');

    /* The popup lives on <body>, so no sticky or transformed column around
       the buy box can clip a fixed element. */
    this.sheet = el.querySelector('[data-k44-sheet]');
    if (this.sheet) document.body.appendChild(this.sheet);
    this.activeSlot = 1;
    this.shown = 0;

    this.bind();
    this.applyBlackFriday();
    this.render();
    this.qa();
  }

  BuyBox.prototype.bind = function () {
    var self = this;

    this.steps.forEach(function (btn) {
      btn.addEventListener('click', function () {
        self.setQty(parseInt(btn.getAttribute('data-k44-step'), 10) || 1);
      });
    });

    this.slotsEl.addEventListener('click', function (event) {
      var action = event.target.closest('[data-k44-slot-action]');
      if (!action) return;
      self.open(parseInt(action.getAttribute('data-slot'), 10));
    });

    if (this.sheet) {
      this.sheet.addEventListener('click', function (event) {
        if (event.target.closest('[data-k44-close]')) { self.close(); return; }
        if (event.target.closest('[data-k44-more]')) { self.page(); return; }
        var pick = event.target.closest('[data-k44-pick]');
        if (pick) self.pick(pick.closest('[data-k44-opt]'));
      });
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && !self.sheet.hidden) self.close();
      });
    }

    /* The theme's own add to cart button (and the sticky bar, which submits
       the same form) adds one kit as before. With 2 or more kits the submit
       is taken over here, in the capture phase, before the theme's
       product-form sees it. */
    document.addEventListener('submit', function (event) {
      /* getAttribute, never form.id: the product form holds an input named
         id, which shadows the property on HTMLFormElement. */
      var form = event.target;
      if (!form || !form.getAttribute || form.getAttribute('id') !== self.formId) return;
      if (!self.live() || self.qty < 2) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      self.add();
    }, true);

    document.addEventListener('kopstorm:flag', function (event) {
      if (event.detail && event.detail.id === 'k44') self.render();
    });
  };

  BuyBox.prototype.live = function () {
    return flagOn() && visible(this.el);
  };

  BuyBox.prototype.setQty = function (qty) {
    var self = this;
    this.qty = qty;
    this.steps.forEach(function (btn) {
      var on = parseInt(btn.getAttribute('data-k44-step'), 10) === qty;
      btn.classList.toggle('is-on', on);
      btn.setAttribute('aria-checked', on ? 'true' : 'false');
      if (on) self.pct = parseInt(btn.getAttribute('data-pct'), 10) || 0;
    });
    var next = [];
    for (var i = 0; i < qty; i++) next.push(this.slots[i] || null);
    next[0] = this.self;
    this.slots = next;
    this.render();
    this.el.dispatchEvent(new CustomEvent('kopstorm:k44:step', { bubbles: true, detail: { qty: qty } }));
  };

  BuyBox.prototype.complete = function () {
    return this.slots.length === this.qty && this.slots.every(Boolean);
  };

  /* Totals the way checkout counts them: kits grouped per variant (one cart
     line each), the tier percentage taken off every line and rounded down to
     the cent, as the automatic Any 2, 3 and 4 discounts do. */
  BuyBox.prototype.totals = function () {
    var lines = {};
    var full = 0;
    var off = 0;
    var pct = this.pct;
    this.slots.forEach(function (kit) {
      if (!kit) return;
      if (!lines[kit.id]) lines[kit.id] = { id: kit.id, price: kit.price, quantity: 0 };
      lines[kit.id].quantity += 1;
    });
    Object.keys(lines).forEach(function (id) {
      var line = lines[id];
      var sum = line.price * line.quantity;
      full += sum;
      off += Math.floor(sum * pct / 100);
    });
    return { lines: lines, full: full, off: off, total: full - off };
  };

  BuyBox.prototype.render = function () {
    this.renderSlots();
    this.renderLine();
    this.renderButtons();
  };

  BuyBox.prototype.renderSlots = function () {
    var self = this;
    var lab = this.labels;
    var before = this.slotsEl.querySelectorAll('.k44-slot').length;
    Array.prototype.slice.call(this.slotsEl.querySelectorAll('.k44-slot')).forEach(function (n) { n.remove(); });
    this.slotsEl.hidden = this.qty < 2;
    if (this.qty < 2) return;

    this.slots.forEach(function (kit, i) {
      var node = self.slotTpl.content.firstElementChild.cloneNode(true);
      var media = node.querySelector('[data-k44-slot-media]');
      var action = node.querySelector('[data-k44-slot-action]');
      node.querySelector('[data-k44-slot-label]').textContent = (lab.kit || 'Kit') + ' ' + (i + 1);
      var name = node.querySelector('[data-k44-slot-name]');

      if (kit) {
        name.textContent = kit.title;
        if (kit.image) {
          var img = new Image();
          img.decoding = 'async';
          if (kit.srcset) { img.srcset = kit.srcset; img.sizes = '44px'; }
          img.src = kit.image;
          img.width = 44;
          img.height = 44;
          img.alt = '';
          img.className = 'k44-img';
          media.appendChild(img);
        }
      } else {
        name.textContent = lab.empty || 'Not chosen yet';
        name.classList.add('is-empty');
        media.classList.add('is-empty');
        media.textContent = String(i + 1);
      }

      if (i === 0) {
        action.replaceWith(Object.assign(document.createElement('span'), {
          className: 'k44-slot__this text-xs',
          textContent: lab.thisKit || 'This kit'
        }));
      } else {
        action.textContent = kit ? (lab.change || 'Change') : (lab.choose || 'Choose');
        action.setAttribute('data-slot', i);
        action.setAttribute('aria-label', action.textContent + ' ' + (lab.kit || 'Kit') + ' ' + (i + 1));
        /* Kits are chosen in order: a line opens once the line above it has
           a kit, so the shopper always knows which one is next. */
        var locked = !kit && i > 1 && !self.slots[i - 1];
        if (locked) {
          node.classList.add('is-locked');
          action.disabled = true;
          action.setAttribute('aria-disabled', 'true');
        }
      }
      /* Only a line that was not there before eases in, so changing a kit
         never makes the other lines blink. */
      if (i >= before) node.classList.add('is-new');
      self.slotsEl.appendChild(node);
    });
  };

  BuyBox.prototype.renderLine = function () {
    var t = this.text;
    var showShip = this.el.getAttribute('data-ship-on') === 'true' || params.get('k44ship') === '1';
    var ship = '';
    if (showShip) {
      if (this.el.getAttribute('data-country') === 'US') {
        if (this.qty >= 4) ship = t.shipUs4 || '';
        else if (this.qty >= 2) ship = t.shipUs2 || '';
        else ship = t.shipUs1 || '';
      } else {
        ship = t.shipRow || '';
      }
    }
    this.shipEl.textContent = ship.replace('[n]', this.qty);

    var save = '';
    if (this.qty > 1 && this.complete()) {
      var tot = this.totals();
      if (tot.off > 0) save = (t.save || 'You save [amount].').replace('[amount]', money(tot.off));
    }
    this.saveEl.textContent = save;
    this.el.querySelector('[data-k44-line]').hidden = !ship && !save;
  };

  /* The theme button keeps its own look. Only its label and price change
     while 2 or more kits are chosen, and go back when the visitor returns to
     1 kit or the flag is switched off. */
  BuyBox.prototype.buttons = function () {
    var id = this.formId;
    return Array.prototype.slice.call(document.querySelectorAll('button[name="add"][form="' + id + '"], #' + id + ' button[name="add"]'));
  };

  BuyBox.prototype.renderButtons = function () {
    var many = this.live() && this.qty > 1;
    var tot = this.totals();
    var t = this.text;
    var text = '';
    if (many) {
      text = this.complete()
        ? (t.addMany || 'Add [n] kits').replace('[n]', this.qty) + ' \u00b7 ' + money(tot.total)
        : (t.chooseKit || 'Choose kit [n]').replace('[n]', this.firstEmpty() + 1);
    }

    this.buttons().forEach(function (btn) {
      var own = btn.querySelector('.k44-btn-label');
      if (!own) {
        own = document.createElement('span');
        var holder = btn.querySelector('.btn-text');
        /* The sticky bar's .btn-text spans are its labels, which step aside,
           so the K_44 label sits next to them as its own .btn-text. */
        if (!holder || holder.classList.contains('kp4-sticky__label')) {
          holder = btn;
          own.className = 'btn-text k44-btn-label';
        } else {
          own.className = 'k44-btn-label';
        }
        holder.appendChild(own);
      }
      own.textContent = text;
      btn.classList.toggle('k44-many', many);
    });

    /* The mobile sticky bar shows the kit count and total instead of the
       single kit price while 2 or more kits are chosen. */
    var sticky = document.querySelector('[data-kp4-sticky]');
    var body = sticky && sticky.querySelector('.kp4-sticky__body');
    if (body) {
      var note = body.querySelector('.k44-sticky-note');
      if (!note) {
        note = document.createElement('p');
        note.className = 'text-xs k44-sticky-note';
        body.appendChild(note);
      }
      var kits = this.qty + ' ' + (t.kitsWord || 'kits');
      note.textContent = this.complete()
        ? kits + ', ' + money(tot.total)
        : kits + ', ' + (t.chooseKit || 'Choose kit [n]').replace('[n]', this.firstEmpty() + 1).toLowerCase();
      sticky.classList.toggle('k44-many', many);
    }
  };

  BuyBox.prototype.firstEmpty = function () {
    for (var i = 1; i < this.slots.length; i++) if (!this.slots[i]) return i;
    return -1;
  };

  /* ---------------------------------------------------------------- popup */
  BuyBox.prototype.open = function (slot) {
    if (!this.sheet) return;
    /* Never open a later line before the one above it has a kit. */
    var gap = this.firstEmpty();
    if (gap > 0 && slot > gap) slot = gap;
    this.activeSlot = slot;
    this.lastFocus = document.activeElement;
    var title = this.sheet.querySelector('[data-k44-sheet-title]');
    if (title) title.textContent = (this.text.sheetTitle || 'Choose kit [n]').replace('[n]', slot + 1);

    var current = this.slots[slot];
    Array.prototype.slice.call(this.sheet.querySelectorAll('[data-k44-opt]')).forEach(function (row) {
      var chosen = !!current && row.getAttribute('data-id') === current.id;
      row.querySelector('[data-k44-pick]').hidden = chosen;
      row.querySelector('[data-k44-chosen]').hidden = !chosen;
      row.classList.remove('is-paged');
      row.hidden = false;
    });

    /* A few kits at a time. Rows a running Early Access week hides by CSS
       are skipped, so the page always holds kits that count. */
    this.list = Array.prototype.slice.call(this.sheet.querySelectorAll('[data-k44-opt]')).filter(function (row) {
      return !row.matches('[data-kop-ea-hide]') || getComputedStyle(row).display !== 'none';
    });
    this.shown = 0;
    this.list.forEach(function (row) { row.hidden = true; });
    this.page();

    this.sheet.hidden = false;
    root.classList.add('k44-lock');
    requestAnimationFrame(function () { this.sheet.classList.add('is-open'); }.bind(this));
    /* Focus moves into the popup without drawing a ring on the Close link. */
    var panel = this.sheet.querySelector('.k44-sheet__panel');
    if (panel) {
      panel.setAttribute('tabindex', '-1');
      panel.focus({ preventScroll: true });
    }
  };

  BuyBox.prototype.page = function () {
    var end = Math.min(this.shown + this.perPage, this.list.length);
    for (var i = this.shown; i < end; i++) this.list[i].hidden = false;
    this.shown = end;
    var more = this.sheet.querySelector('[data-k44-more]');
    if (more) more.parentNode.hidden = this.shown >= this.list.length;
  };

  BuyBox.prototype.close = function () {
    if (!this.sheet || this.sheet.hidden) return;
    var sheet = this.sheet;
    sheet.classList.remove('is-open');
    root.classList.remove('k44-lock');
    window.setTimeout(function () { sheet.hidden = true; }, 380);
    if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus({ preventScroll: true });
  };

  BuyBox.prototype.pick = function (row) {
    if (!row) return;
    this.slots[this.activeSlot] = {
      id: row.getAttribute('data-id'),
      price: parseInt(row.getAttribute('data-price'), 10) || 0,
      title: row.getAttribute('data-title'),
      image: row.getAttribute('data-image'),
      srcset: row.getAttribute('data-srcset')
    };
    this.close();
    this.render();
  };

  /* ------------------------------------------------------------ add to cart */
  BuyBox.prototype.add = function () {
    var gap = this.firstEmpty();
    if (gap > 0) { this.open(gap); return; }

    var tot = this.totals();
    var items = Object.keys(tot.lines).map(function (id) {
      return { id: parseInt(id, 10), quantity: tot.lines[id].quantity };
    });
    var btns = this.buttons();
    btns.forEach(function (b) { b.setAttribute('aria-busy', 'true'); b.disabled = true; });
    var routes = (window.theme && window.theme.routes) || {};
    var self = this;

    /* No sections in the body on purpose: assets/kopstorm-cart.js sees a
       plain /cart/add, repaints the custom drawer and opens it, and the free
       gift script folds the dust covers in from the same request. */
    fetch((routes.cart_add_url || '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res && res.status) throw new Error(res.description || res.message || 'Add failed');
        self.el.dispatchEvent(new CustomEvent('kopstorm:k44:add', { bubbles: true, detail: { qty: self.qty, items: items, total: tot.total } }));
      })
      .catch(function (err) {
        console.error('[kopstorm-k44]', err);
        var msg = document.querySelector('#' + self.formId + ' .product-form__error-message');
        if (msg) { msg.textContent = err.message; msg.hidden = false; }
      })
      .then(function () {
        btns.forEach(function (b) { b.removeAttribute('aria-busy'); b.disabled = false; });
      });
  };

  /* ------------------------------------------------------- Black Friday */
  BuyBox.prototype.applyBlackFriday = function () {
    var tz = this.el.getAttribute('data-tz');
    var start = storeTime(this.el.getAttribute('data-bf-start'), tz);
    var end = storeTime(this.el.getAttribute('data-bf-end'), tz);
    var now = Date.now();
    var on = params.get('k44bf') === '1' || (start > 0 && now >= start && (!end || now < end));
    var label = this.el.querySelector('[data-k44-bf]');
    var heading = this.el.querySelector('[data-k44-heading]');
    if (label) label.hidden = !on;
    if (heading && on && heading.getAttribute('data-bf')) heading.textContent = heading.getAttribute('data-bf');
    this.el.classList.toggle('is-bf', on);
  };

  /* ----------------------------------------------------------------- QA */
  BuyBox.prototype.qa = function () {
    var q = parseInt(params.get('k44q'), 10);
    if (q > 1 && this.steps.some(function (b) { return b.getAttribute('data-k44-step') === String(q); })) this.setQty(q);
    var handle = params.get('k44kit');
    if (handle && this.qty > 1 && this.sheet) {
      var row = this.sheet.querySelector('[data-k44-opt][data-handle="' + handle.replace(/"/g, '') + '"]');
      if (row) { this.activeSlot = 1; this.pick(row); }
    }
    if (params.get('k44sheet') === '1') {
      if (this.qty < 2) this.setQty(2);
      var gap = this.firstEmpty();
      this.open(gap > 0 ? gap : 1);
    }
  };

  /* ------------------------------------------------------ fading promises */
  /* Promises under add to cart. Under the flag the V4 row steps aside for a
     one line ticker built from copies of its own promises (theme icon and
     title). One promise at a time slides up into view with a GPU transform,
     so two promises never sit on top of each other. A copy of the first
     promise at the end makes the loop seamless. The control arm keeps the V4
     row as it is. */
  var USP_H = 44;

  function promiseTicker(box) {
    var info = box.closest('.kp4-main__info') || document;
    var wrap = info.querySelector('[data-k44-usp]');
    if (!wrap || wrap.__k44Ticker) return;
    wrap.__k44Ticker = true;
    var list = wrap.querySelector('.k44-usp__list');
    var n = parseInt(wrap.getAttribute('data-count'), 10) || 0;
    if (!list || n < 2) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var i = 0;
    function go(index, animate) {
      list.style.transition = animate ? '' : 'none';
      list.style.transform = 'translate3d(0,' + (-USP_H * index) + 'px,0)';
    }
    list.addEventListener('transitionend', function () {
      if (i === n) { i = 0; go(0, false); }
    });
    window.setInterval(function () {
      if (!flagOn() || document.hidden || !visible(wrap)) return;
      i += 1;
      go(i, true);
    }, 3200);
  }

  /* The popup photos load with the page at low priority. Once the browser is
     idle they are decoded too, so opening the popup paints every photo at
     once instead of one by one. */
  function warm(box) {
    var sheet = box.sheet;
    if (!sheet) return;
    var run = function () {
      Array.prototype.forEach.call(sheet.querySelectorAll('img'), function (img) {
        if (img.decode) img.decode().catch(function () { /* not loaded yet */ });
      });
    };
    if (window.requestIdleCallback) window.requestIdleCallback(run, { timeout: 2500 });
    else window.setTimeout(run, 1200);
    box.el.addEventListener('pointerdown', run, { once: true, passive: true });
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-k44]'), function (el) {
      if (el.__k44) return;
      el.__k44 = new BuyBox(el);
      warm(el.__k44);
      promiseTicker(el);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
